const routeNames = {
    'contato':'contacto',
    'contacto': 'contato',
    'politica-de-privacidade':'politica-de-privacidad',
    'politica-de-privacidad':'politica-de-privacidade',
}

export default routeNames;